import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import { Cart } from "../../pages/Cart/Cart";
import { Landing } from "../../pages/landing";
import Footer from "../Footer/Footer";
import LoginPage from "../../pages/Login/LoginPage";
import { OrderReview } from "../../pages/PaymentPage/orderReview";
import Products from "../../pages/ProductPage/Products";
import { useSelector } from "react-redux";
import { PrivateRoute } from "../../context/PrivateRoute";
import ErrorPage from "../../pages/ErrorPage";
import Dash from "../../pages/Dashboard/Dash";
import Aboutudyog from "../../pages/footertags/aboutus";
import Digitalstore from "../../pages/Navbarlandingpages/Digitalstore";
import BoostSales from "../../pages/Navbarlandingpages/Boostsales";
import Customizedproducts from "../../pages/Navbarlandingpages/Storecustomized";
import Funds from "../../pages/Navbarlandingpages/Funds";

import DashboardLayout from "../../pages/userdash/dashboardlayout";
import Page from "../../pages/userdash/profile";
import { ProductsTable } from "../../pages/userdash/productsTable";
import OrderPage from "../../pages/userdash/orderPage";
import { OrderDetails } from "../../pages/userdash/orderdetails";
import Invoice from "../../Invoice_Generation/invoice";


import About from "../../pages/footertags/about";
import Customers from "../../pages/footertags/customers";
import News from "../../pages/footertags/news";
import Career from "../../pages/footertags/career";
import Terms from "../../pages/footertags/terms";
import Privacy from "../../pages/footertags/privacy";
import Fee from "../../pages/footertags/fee";
import Shipping from "../../pages/footertags/shipping";
import Return from "../../pages/footertags/return";
import Contact from "../../pages/footertags/contact";
import Browse from "../../pages/footertags/browse";
import Health from "../../pages/footertags/health";
import Offers from "../../pages/footertags/offers";
import FAQs from "../../pages/footertags/faqs";




export const AllRoutes = () => {
  const mobileView = useSelector((state) => state.mobileView);
  const is_user = localStorage.getItem("isSeller");

  return (
    <Routes>
      { is_user  
      ?<>
      <Route path="/" element={<Link to='/dashboard'><button>YOU SEEMS TO BE LOST CLICK HERE</button></Link>} />
      <Route path="*"element={<ErrorPage />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dash />
            </PrivateRoute>
          }
        ></Route>
        <Route path="/Login" element={<LoginPage></LoginPage>}></Route>
      </>
      :<>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Landing /> <Footer />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/products"
        element={
          <PrivateRoute>
            <Products /> <Footer />
          </PrivateRoute>
        }
      ></Route>
      <Route path="/Login" element={<LoginPage></LoginPage>}></Route>
      <Route path="/cart" element={<PrivateRoute><Cart /></PrivateRoute>}></Route>
      <Route
        path="/payment"
        element={
          <PrivateRoute>
            <OrderReview></OrderReview>
          </PrivateRoute>
        }
      ></Route>
      <Route path="/digitalstore" element={<Digitalstore />}></Route>
      <Route path="/boostsales" element={<PrivateRoute><BoostSales /><Footer /></PrivateRoute>}></Route>
      <Route path="/customizedproducts" element={<Customizedproducts />}></Route>
      <Route path="/fundsforbusiness" element={<Funds />}></Route>
      <Route path="/aboutus" element={<Aboutudyog />}></Route>
      
      <Route path="/user/dashboard" element={<PrivateRoute><DashboardLayout children={<Page />}/></PrivateRoute>}></Route>
      <Route path="/user/dashboard/profile" element={<PrivateRoute><DashboardLayout children={<Page />}/></PrivateRoute>}></Route>
      <Route path="/user/dashboard/inventory" element={<PrivateRoute><DashboardLayout children={<ProductsTable />}/></PrivateRoute>}></Route>
      <Route path="/user/dashboard/orders" element={<PrivateRoute><DashboardLayout children={<OrderPage />}/></PrivateRoute>}></Route>
      <Route path="/user/dashboard/orders/abc" element={<PrivateRoute><DashboardLayout children={<OrderDetails />}/></PrivateRoute>}></Route>
      <Route path="/user/dashboard/orders/invoice" element={<PrivateRoute><DashboardLayout children={<Invoice />}/></PrivateRoute>}></Route>


      <Route path="/about" element={<About />}></Route>
      <Route path="/customers" element={<Customers />}></Route>
      <Route path="/news" element={<News />}></Route>
      <Route path="/career" element={<Career />}></Route>
      <Route path="/terms" element={<Terms />}></Route>
      <Route path="/privacy" element={<Privacy />}></Route>
      <Route path="/fee" element={<Fee />}></Route>
      <Route path="/shipping" element={<Shipping />}></Route>
      <Route path="/return" element={<Return />}></Route>
      <Route path="/contact" element={<Contact />}></Route>
      <Route path="/browse" element={<Browse />}></Route>
      <Route path="/health" element={<Health />}></Route>
      <Route path="/offers" element={<Offers />}></Route>
      <Route path="/faqs" element={<FAQs />}></Route>

      <Route path="*"element={<ErrorPage />} />  
      </>
      }
    </Routes>
  );
};
